import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './ListSection.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const ListFilter: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <div className={concatClassName(styles['filter'], className)}>
        {children}
    </div>
);

ListFilter.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

ListFilter.defaultProps = {
    className: undefined,
    children: undefined
};

export default ListFilter;
